<template>
    <main>
        <div class="common-report unit-coutry-turnover-set-s">
            <qcentriscountry-relation></qcentriscountry-relation>
            <qcentriscountry-allocation></qcentriscountry-allocation>
        </div>
    </main>
</template>

<script>

    import QcentriscountryRelation from "./qcentris-country-turnover/qcentriscountryRelation";
    import QcentriscountryAllocation from "./qcentris-country-turnover/qcentriscountryAllocation";

    export default {
        name: "QcentrisCountryTurnover",
        components: {QcentriscountryAllocation, QcentriscountryRelation},
        computed: {
            filter: function () {
                return this.$store.state.reports.qcentrisCountryTurnoverFilter;
            }
        },
        beforeMount() {
            this.fetchData();
        },
        methods: {
            fetchData: function () {
                this.$store.dispatch("fetchCountryTurnover", this.filter);
                this.$store.dispatch("fetchReportAggregates", this.filter);
            }
        }
    }
</script>

<style scoped>
</style>